var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3px",
    height: "11px",
    viewBox: "0 0 3 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "061C3A46-87CF-47A7-8D1A-A38161F0BB01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master-Landing-/-Compliance",
    transform: "translate(-622.000000, -306.000000)",
    fill: "#B6B6B6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(288.613530, 251.729800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.969905,62.4161085 C335.539622,62.4161085 336.001469,62.8779554 336.001469,63.4476725 C336.001469,64.0173896 335.539622,64.4792365 334.969905,64.4792365 C334.400188,64.4792365 333.938341,64.0173896 333.938341,63.4476725 C333.938341,62.8779554 334.400188,62.4161085 334.969905,62.4161085 Z M334.969905,58.7702002 C335.539622,58.7702002 336.001469,59.2320472 336.001469,59.8017642 C336.001469,60.3714813 335.539622,60.8333283 334.969905,60.8333283 C334.400188,60.8333283 333.938341,60.3714813 333.938341,59.8017642 C333.938341,59.2320472 334.400188,58.7702002 334.969905,58.7702002 Z M334.969905,55.124292 C335.539622,55.124292 336.001469,55.5861389 336.001469,56.155856 C336.001469,56.7255731 335.539622,57.18742 334.969905,57.18742 C334.400188,57.18742 333.938341,56.7255731 333.938341,56.155856 C333.938341,55.5861389 334.400188,55.124292 334.969905,55.124292 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu-dots.e84e431bc941bf7fc30fe671bee4d23c.svg";
export { ForwardRef as ReactComponent };